"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var video_deal_info_1 = require("@wix/wix-vod-constants/dist/common/video-deal-info");
var transcoding_statuses_1 = require("@wix/wix-vod-constants/dist/common/transcoding-statuses");
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var time_1 = require("../utils/time");
var entity_id_1 = require("../normalizers/entity-id");
var DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };
var normalizeTranscodingStatus = function (status) {
    if (status === transcoding_statuses_1.TRANSCODING_STATUSES_V2.INIT) {
        return transcoding_statuses_1.TRANSCODING_STATUSES.NONE;
    }
    if (_.includes(transcoding_statuses_1.TRANSCODING_STATUSES, status)) {
        return status;
    }
    return transcoding_statuses_1.TRANSCODING_STATUSES.NONE;
};
exports.parseVideoItem = function (itemData) {
    var camelCasedItemData = object_1.keysToCamelCase(itemData);
    var itemId = camelCasedItemData.itemId, externalId = camelCasedItemData.externalId, listId = camelCasedItemData.listId, mediaStatus = camelCasedItemData.mediaStatus, trailerStatus = camelCasedItemData.trailerStatus, mediaInfo = camelCasedItemData.mediaInfo, mediaExternUrl = camelCasedItemData.mediaExternUrl, _a = camelCasedItemData.downloadOptions, allowDownload = (_a === void 0 ? DEFAULT_DOWNLOAD_OPTIONS : _a).allowDownload, _b = camelCasedItemData.videoSource, videoSource = _b === void 0 ? video_sources_1.VIDEO_SOURCES.COMPUTER : _b;
    var id = (itemId && entity_id_1.normalizeId(itemId)) || externalId;
    var _c = camelCasedItemData.customCoverUrl, customCoverUrl = _c === void 0 ? null : _c, createdTsNum = camelCasedItemData.createdTs, updatedTsNum = camelCasedItemData.updatedTs, publishedTsNum = camelCasedItemData.publishTs, usedInLists = camelCasedItemData.usedInLists;
    var dealInfo = camelCasedItemData.dealInfo, durationSec = camelCasedItemData.durationSec, durationStr = camelCasedItemData.durationStr, _d = camelCasedItemData.tags, tags = _d === void 0 ? [] : _d, _e = camelCasedItemData.categories, categories = _e === void 0 ? [] : _e;
    var createdTs = new Date(createdTsNum * 1000);
    var updatedTs = new Date(updatedTsNum * 1000);
    var publishTs = publishedTsNum ? new Date(publishedTsNum * 1000) : null;
    //TODO think about refactor to keep refs in 'usedInLists'
    var listsRefs = _.reduce(usedInLists, function (refs, listItem) {
        var _a;
        return (tslib_1.__assign({}, refs, (_a = {}, _a[listItem.itemId] = listItem.refItemId, _a)));
    }, {});
    var mappedUsedInLists = _.map(usedInLists, function (_a) {
        var listItemId = _a.itemId, title = _a.title;
        return ({
            id: listItemId,
            title: title,
        });
    });
    var fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
    if (fileInputDurationSec) {
        durationSec = Math.floor(fileInputDurationSec / 1000);
        durationStr = time_1.convertSSToMMSS(durationSec);
    }
    if (!durationStr) {
        durationStr = time_1.convertSSToMMSS(durationSec);
    }
    var transcodingStatus = normalizeTranscodingStatus(mediaExternUrl ? transcoding_statuses_1.TRANSCODING_STATUSES.READY : mediaStatus);
    var trailerTranscodingStatus = normalizeTranscodingStatus(trailerStatus);
    // external videos should be free
    if (mediaExternUrl) {
        dealInfo = video_deal_info_1.FREE_VIDEO_DEAL_INFO;
    }
    tags = _.uniq(tags);
    categories = _.uniq(categories);
    var normalizedListId = entity_id_1.normalizeId(listId);
    var clearCamelCasedItemData = _.omit(camelCasedItemData, [
        'downloadOptions',
        'mediaStatus',
        'trailerStatus',
    ]);
    var mappedCamelCasedItemData = tslib_1.__assign({}, clearCamelCasedItemData, { id: id, listId: normalizedListId, customCoverUrl: customCoverUrl,
        transcodingStatus: transcodingStatus,
        trailerTranscodingStatus: trailerTranscodingStatus,
        dealInfo: dealInfo,
        durationSec: durationSec,
        durationStr: durationStr,
        createdTs: createdTs,
        updatedTs: updatedTs,
        publishTs: publishTs, usedInLists: mappedUsedInLists, listsRefs: listsRefs,
        allowDownload: allowDownload,
        videoSource: videoSource,
        tags: tags,
        categories: categories });
    return object_1.removeUndefinedValues(mappedCamelCasedItemData);
};
//# sourceMappingURL=video-item.js.map